import { AfterViewInit, Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { PATH } from '../app.api'

@Injectable()
export class MetabaseService {
	constructor(private http: HttpClient) {}

	public getMetabaseEmbeddedUrl(companyId: String): Observable<string> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/metabase/graphics/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
          console.log(result)
					return result.url
				})
			)
	}

		private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' })
	}
}
